import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { AreArraysEqualByKeyAndValues } from 'src/app/supporting/General';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BillingStatus, BusinessEnabledOption, CommunicationTemplate, CustomLabelInputType, CustomPrintLabelForBill, CustomPrintLabelForBills, FocusInputType, GeneralConfigType, InteractionType, KeyValueId, KeyValues5, KeyValueSet, LastUsedKey, LastUsedSettingsType, LocalService, OtpType, PageKey, Status, TriggeredEvent, Wrappers10 } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-receipt-custom-labels',
  templateUrl: './receipt-custom-labels.component.html',
  styleUrl: './receipt-custom-labels.component.scss'
})
export class ReceiptCustomLabelsComponent {
  CommunicationTemplate = CommunicationTemplate; CustomLabelInputType = CustomLabelInputType;
  lstSectionConfigKeys: string[] = ["billing"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0; billingId: string = '';

  source: CustomPrintLabelForBills; sourceGrouped: CustomPrintLabelForBills; itemsBeforeSave: CustomPrintLabelForBill[] = []; selectedLanguageId: string = ''; selectedTabKey: string = ''; savedCustomLabels: KeyValues5[] = []; selectedSavedCustomLabelId = ''; receiptOptions: KeyValueSet[] = [];
  tabs: KeyValueSet[] = []; searchKey: string = ''; isShowSaveAs = false; titleToSave = ''; isNewTitle = true; isShowPreview = false; relationShipType = InteractionType.Business;
  isPrint = false; isShowSendToPhone: boolean = false; isOpenSendToPhone: boolean = false; isOpenPaymentModes: boolean = false;
  total: number = 0; isPrintOncePaid: boolean = false; isFooterbarShow = true; isGridView = true; marginLeft: number = 0; isOpenCamera = false; isShowOnlyAcceptAndPrintButtonInCustomReceiptPage: boolean = true; isLockFieldsIfAccepted: boolean = true; isLockPreviewOfDefault: boolean = false;
  selectedId: string = '';

  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private el: ElementRef, private router: Router, private modalService: NgbModal, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private billingManagementService: BillingManagementService, private profileManagementService: ProfileManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save: "btn_custom_label_print_bill_save_" + this.htmlId,
      title: 'txt_custome_label_print_bill_title_' + this.htmlId,
      value: 'txt_custome_label_print_bill_value_' + this.htmlId + '_',
      save_as: "btn_custom_label_print_bill_save_as_" + this.htmlId,
      cancel: "btn_custom_label_print_cancel_" + this.htmlId,
      create: "btn_custom_label_bill_print_create_" + this.htmlId,
      txt_title: "btn_custom_label_print_bill_txt_title_" + this.htmlId,
      btn_clear: "btn_custom_label_print_bill_btn_clear_" + this.htmlId,
      dd_language: 'dd_language_' + this.htmlId,
      btn_accept: 'btn_accept_' + this.htmlId,
      btn_paid: 'btn_paid_' + this.htmlId,
      brn_search_billing_customer: 'brn_search_billing_customer_' + this.htmlId,
      show_more: 'show_more_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;
      this.billingId = routeParams.id;

      this.configurationManagementService.ensurePageActions(PageKey.ReceiptCustomLabels);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.selectedLanguageId = this.localService.getSelectedLanguageId();

    if (!this.localService.receiptOptions) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ReceiptOption, true).subscribe(result => {
        this.localService.receiptOptions = result;
        this.receiptOptions = this.localService.receiptOptions;
        this.onLoad(true);
      });
    } else {
      this.receiptOptions = this.localService.receiptOptions;
      this.onLoad(true);
    }
  }

  onLoad(isInital: boolean = false) {
    if (this.businessId && this.businessId.length > 5 && this.billingId && this.billingId.length > 0) {
      if (this.billingId.length > 5) {
        this.onLoadSavedCustomeLabels();
      }
      this.billingManagementService.getCustomLabelPrintByBillingId(this.businessId, this.selectedLanguageId, this.billingId, isInital).subscribe(result => {
        if (result.redirectBillingId && result.redirectBillingId.length > 0) {
          this.router.navigate(['/receipt-custom-labels-new' + this.localService.basicParamsString, this.businessId, result.redirectBillingId]);
        } else {
          this.source = result;
          this.itemsBeforeSave = JSON.parse(JSON.stringify(this.source.items));
          this.onSetTokenNumber();
          if (!(this.selectedTabKey && this.selectedTabKey.length > 0) && this.source.replaceOptions && this.source.replaceOptions.length > 0) {
            this.onSetFilterReplaceOption(isInital);
          }
          this.onSetOrExtractGroup(true);
        }
      });
    }
  }

  isDraftMode: boolean = false;
  onSetTokenNumber() {
    this.localService.tokenNumber = this.source.content.v1 && this.source.content.v1.length > 1 ? this.source.content.v1 : (this.localService.languageContent && this.localService.languageContent.billing ? this.localService.languageContent.billing.draft : 'Draft');
    this.isDraftMode = this.localService.tokenNumber == 'Draft';
  }

  onLoadSavedCustomeLabels() {
    this.savedCustomLabels = [];
    this.selectedSavedCustomLabelId = '';
    this.billingManagementService.getSavedCustomLabels(this.businessId, this.selectedLanguageId).subscribe(result => {
      this.savedCustomLabels = result;
      this.onGetLastUsedSettings();
    });
  }

  onSetFilterReplaceOption(isInital: boolean = false) {
    if (isInital) {
      this.isShowSendToPhone = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.ShowSmsButtonInBillingPage);
      this.isPrintOncePaid = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.PrintOncePaid);
      this.isShowOnlyAcceptAndPrintButtonInCustomReceiptPage = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsShowOnlyAcceptAndPrintButtonInCustomReceiptPage);
      this.isLockFieldsIfAccepted = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.LockCustomLabelsIfAccepted) || this.interactionType != InteractionType.Business;
      this.isLockPreviewOfDefault = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.LockPreviewPrintReceiptOfDefault);

      this.tabs = [];
      this.source.replaceOptions.forEach(option => {
        if (!this.isLockPreviewOfDefault || (this.isLockPreviewOfDefault && option.text != 'Default')) {
          this.tabs.push({
            key: option.id,
            value: (option.text ?? 'N/A') + ' (' + this.source.items.filter(x => x.isPinned && x.printerTemplateId == option.id).length + '/' + this.source.items.filter(x => x.printerTemplateId == option.id).length + ')'
          } as KeyValueSet);
        }
      });
      if (this.tabs.length > 0) {
        this.selectedTabKey = this.tabs[0].key;
      }

      this.total = parseFloat(this.source.content.v5);

      this.isFooterbarShow = this.source.content.v3 == '0' || !(this.source.content.v1?.length > 0);
    }

    setTimeout(() => {
      const firstElement = this.el.nativeElement.querySelector(
        'input[id^="txt_custome_label_print_bill_value_"], textarea[id^="txt_custome_label_print_bill_value_"]'
      ) as HTMLInputElement | HTMLTextAreaElement | null;

      if (firstElement) {
        this.localService.onFocusNextInput(firstElement.id, FocusInputType.TextBox);
      }
    }, 500);
  }

  ngOnDestroy(): void {
    this.localService.tokenNumber = '';
  }

  onFillFromSavedCustomLabels() {
    if (this.selectedSavedCustomLabelId && this.selectedSavedCustomLabelId.length > 5) {
      this.billingManagementService.getSavedCustomLabelDetails(this.selectedSavedCustomLabelId).subscribe(result => {
        result.forEach(item => {
          let customLabelItem = this.source.items.find(x => x.key == item.key);
          if (customLabelItem) {
            customLabelItem.value = item.value;
          }
        });
        this.onSave();
      });
    }
  }

  onCheckNewTitle() {
    const searchKey = this.titleToSave.trim().toLocaleLowerCase();
    const item = this.savedCustomLabels.find(x => x.v3 == searchKey);
    this.isNewTitle = item ? false : true;
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSave(false);
      } break;
      case 2: {
        this.titleToSave = '';
        if (this.selectedSavedCustomLabelId && this.selectedSavedCustomLabelId.length > 0) {
          const item = this.savedCustomLabels.find(x => x.key == this.selectedSavedCustomLabelId);
          if (item) {
            this.titleToSave = item.v1;
          }
        }
        this.onCheckNewTitle();
        this.isShowSaveAs = true;
        this.localService.onFocusNextInput(this.elementIds.txt_title, FocusInputType.TextBox, false, true);
      } break;
      case 3: {
        this.isShowSaveAs = false;
      } break;
      case 4: {
        this.onSaveAs();
      } break;
      case 5: {
        this.onClearCustomLabels();
      } break;
      case 6: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, this.billingId]);
      } break;
      case 7: {
        if (!this.isGridView) {
          this.isGridView = !this.isGridView;
          this.onSaveLastUsedSettings();
        }
        this.onSetMargin();
      } break;
      case 8: {
        if (this.isGridView) {
          this.isGridView = !this.isGridView;
          this.onSaveLastUsedSettings();
        }
        this.onSetMargin();
      } break;
      case 9: {
        this.selectedId = key;
        this.isOpenCamera = true;
      } break;
    }
  }

  onSaveLastUsedSettings() {
    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.IsListViewInReceiptCustomLabel);
    const status: string = this.isGridView ? '0' : '1';
    if (temp != status)
      items.push({ keyType: LastUsedSettingsType.IsListViewInReceiptCustomLabel, value: status } as LastUsedKey);

    if (items.length > 0) {
      this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
      });
    }
  }

  onGetLastUsedSettings() {
    const temp = this.localService.getLastUsedSetting(LastUsedSettingsType.IsListViewInReceiptCustomLabel);
    if (temp) {
      this.isGridView = temp == '0';
    }
    this.onSetMargin();
  }

  onSetMargin() {
    if (!this.isGridView && window.innerWidth > 500) {
      this.marginLeft = (window.innerWidth - 500) / 2;
    } else {
      this.marginLeft = 0;
    }
  }

  onSaveAs() {
    if (this.businessId && this.businessId.length > 5) {
      const customLabelDetails: KeyValueSet[] = this.source.items.filter(x => x.isPinned).map(function (x) {
        return {
          isSelected: x.isSelected,
          key: x.key,
          value: x.value
        } as KeyValueSet;
      });
      this.billingManagementService.saveSavedCustomLabel(this.businessId, this.selectedLanguageId, this.titleToSave, customLabelDetails).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.isShowSaveAs = false;
          this.onLoadSavedCustomeLabels();
        }
      });
    }
  }

  onSelectionChanged(data: any, isMultiSelect: boolean, key: string) {
    let item = this.source.items.find(x => x.key == key);
    if (item) {
      item.value = data ? (isMultiSelect ? (data as string[]).join('\n') : data) : '';
      this.onSave();
    }
  }

  onSelectionRemoved(data: any, isMultiSelect: boolean, key: string) {
    let item = this.source.items.find(x => x.key == key);
    if (item) {
      item.value = '';
      this.onSave();
    }
  }

  onSetOrExtractGroup(isSetGroup: boolean) {
    if (isSetGroup) {
      this.sourceGrouped = JSON.parse(JSON.stringify(this.source));
      this.sourceGrouped.items.forEach(item => {
        const groupKey = item.groupBy;
        if (groupKey && groupKey.length > 0) {
          let parentItem = this.sourceGrouped.items.find(x => x.title == groupKey);
          if (!parentItem.groupedItems) {
            parentItem.groupedItems = [];
          }
          parentItem.groupedItems.push(item);
        }
      });
      this.sourceGrouped.items = this.sourceGrouped.items.filter(x => !(x.groupBy?.length > 0));
    } else {

    }
  }

  onSave(isSilentSave: boolean = true, currentKey?: string) {
    if (this.businessId && this.businessId.length > 5 && this.billingId && this.billingId.length > 5) {
      if (!AreArraysEqualByKeyAndValues(this.itemsBeforeSave, this.source.items)) {
        this.source.items.filter(x => parseInt(x.customLabelInputType) == CustomLabelInputType.SingleInputBox).forEach(item => {
          const hasDoubleQuotes = item.value.endsWith("\"");
          item.value = this.ConvertToUnicodeInches(item.value);
        });
        this.source.items.filter(x => parseInt(x.customLabelInputType) == CustomLabelInputType.HourOrDayInput).forEach(item => {
          if (!(item.value.endsWith("h") || item.value.endsWith("d"))) {
            const numbers = item.value.replace(/\D/g, "");
            item.value = numbers + "h";
          }
        });
        if (currentKey && currentKey.length > 0) {
          const item = this.source.items.find(x => x.key == currentKey);
          // this.source.items.filter(x => x.receiptCustomeLabelReplace == item.receiptCustomeLabelReplace && !(x.value && x.value.length > 0) && x.key != item.key).forEach(x => {
          //   x.value = item.value;
          // });

          this.source.items.filter(x => x.receiptCustomeLabelReplace == item.receiptCustomeLabelReplace && x.printerTemplateId == '000000000000000000000000' && x.key != item.key).forEach(x => {
            x.value = item.value;
          });
        }
        this.billingManagementService.saveCustomLabelPrintByBillingId(this.selectedLanguageId, this.billingId, this.source.items, isSilentSave).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          this.itemsBeforeSave = JSON.parse(JSON.stringify(this.source.items));
        });
      }
    }
  }

  onClearCustomLabels() {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.billing.clear_custom_label_confimation;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.selectedSavedCustomLabelId = '';
        this.source.items.filter(x => x.isPinned).forEach(x => {
          x.value = '';
        });
        this.onSave();
      }
    });
  }

  onPrint() {
    this.isPrint = true;
  }

  onPrinted() {
    this.isPrint = false;
  }

  onSendToPhone() {
    this.isOpenSendToPhone = true;
  }

  onUpdateStatus(status: BillingStatus) {
    this.billingManagementService.updateBillingStatus(this.billingId, status).subscribe(result => {
      this.localService.showInformationByStatus(result.responseStatus.status);

      if (result.responseStatus.status == Status.Success) {
        this.onEnsureTokenNumber();
      }
    });
  }

  onPaid(res: any) {
    const status: Status = res.status;
    const isPrint: boolean = res.isPrint;
    const isSendToPhone: boolean = res.isSendToPhone;
    switch (status) {
      case Status.NeedBRN: {
        this.localService.showMessage(this.localService.languageContent.billing.need_customer_brn);
      } break;
      case Status.Success: {
        this.source.content.v3 = '1';
        this.onEnsureTokenNumber();

        if (isPrint) {
          this.onPrint();
        }

        if (isSendToPhone) {
          this.onSendToPhone();
        }
      } break;
      default: {
        this.localService.showInformationByStatus(status);
      } break;
    }
  }

  onEnsureTokenNumber() {
    if (!(this.source.content.v1?.length > 0)) {
      this.billingManagementService.getTokenByBillingId(this.billingId).subscribe(result => {
        this.source.content.v1 = result.value ?? '';
        if (this.isShowOnlyAcceptAndPrintButtonInCustomReceiptPage) {
          this.onPrint();
        }
        this.onSetTokenNumber();
      });
    } else {
      if (this.isShowOnlyAcceptAndPrintButtonInCustomReceiptPage) {
        this.onPrint();
      }
    }
  }

  onUserUpdated(index: number, userId) {
    this.billingManagementService.updateBusinessBRN(userId, this.billingId, this.businessId, index == 1 || index == 3, index == 3).subscribe(result => {
      this.localService.showInformationByStatus(result.status);

      if (result.status == Status.Success) {
        this.source.content.v4 = userId;
      }
    });
  }

  FRACTION_MAP: Record<string, string> = {
    '1/2': '½',
    '1/3': '⅓',
    '2/3': '⅔',
    '1/4': '¼',
    '3/4': '¾',
    '1/5': '⅕',
    '2/5': '⅖',
    '3/5': '⅗',
    '4/5': '⅘',
    '1/6': '⅙',
    '5/6': '⅚',
    '1/8': '⅛',
    '3/8': '⅜',
    '5/8': '⅝',
    '7/8': '⅞'
  };

  ConvertToUnicodeInches(value: string): string {
    return value.replace(
      /\b(\d+)\s+(\d+\/\d+)"\b|\b(\d+\/\d+)"\b/g,
      (match, whole, fraction1, fraction2) => {
        const fraction = fraction1 || fraction2;
        const unicode = this.FRACTION_MAP[fraction];

        if (!unicode) return match;

        return whole ? `${whole}${unicode}"` : `${unicode}"`;
      }
    );
  }

  isEndsWitDay(value: string): boolean {
    return value?.endsWith("d");
  }

  onSetHoursDay(index: number, key: string) {
    let item = this.source.items.find(x => x.key == key);
    if (!item) return;
    const numbers = item.value.replace(/\D/g, "");

    switch (index) {
      case 1: {
        item.value = numbers + "h";
      } break;
      case 2: {
        item.value = numbers + "d";
      } break;
      default: {
        item.value = numbers + (this.isEndsWitDay(item.value) ? "d" : "h");
      } break;
    }
    this.onSave();
  }

  onCaptured(data: KeyValueId) {
    if (data) {
      let item = this.source.items.find(x => x.key == data.key);
      if (item) {
        this.billingManagementService.saveImage(data.value as string, this.businessId, this.billingId, item.key, item.value).subscribe(result => {
          if (result.status == Status.Success) {
            item.value = result.id;
            this.onSave();
          }
        });
      }
    }
  }
}
